module.exports = __webpack_public_path__ + "img/potrait-service-blue.fae61f77.png";